import React, { FC } from 'react'
import PlaceholderSvg from '../assets/icons/icon_q.svg'
import { useTranslations } from '../hooks/useTranslations'

export const PlaceholderImage: FC = () => {
  const translations = useTranslations()
  return (
    <PlaceholderSvg
      aria-label={translations.placeholderImage ?? ''}
      className="h-full w-full fill-current text-placeholder-image"
      role="img"
    />
  )
}
